module.exports = __webpack_public_path__ + "static/media/excelent.7ab4ade5.png";